import { useBatchCreateProductPositions } from "./useBatchCreateProductPositions"
import { useCreateProductPosition } from "./useCreateProductPosition"
import { useDeleteProductPosition } from "./useDeleteProductPosition"
import { useUpdateProductPosition } from "./useUpdateProductPosition"

export function useProductPositionMutations() {
  const [createProductPosition] = useCreateProductPosition()
  const [updateProductPosition] = useUpdateProductPosition()
  const [deleteProductPosition] = useDeleteProductPosition()
  const [batchCreateProductPositions] = useBatchCreateProductPositions()

  return {
    createProductPosition,
    updateProductPosition,
    deleteProductPosition,
    batchCreateProductPositions
  }
}
